<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols="12" md="6">
                    <v-card class="my-5">
                        <v-card-title class="headline">
                            <v-icon class="mr-2">mdi-api</v-icon> {{ $t('views.main.api.api.ws_integration') }}
                        </v-card-title>

                        <v-card-text>
                            <p>
                                {{ $t('views.main.api.api.ws_integration_description') }}
                            </p>
                            <p>
                                <a href="/documents/Jarstol-WebService-API-v1.1.1.pdf" target="_blank">
                                    <v-icon class="mr-2">mdi-download</v-icon>
                                    {{ $t('views.main.api.api.api_documentation_link') }}
                                </a>
                            </p>
                            <p>
                                <a href="https://documenter.getpostman.com/view/11647405/U16huSsV" target="_blank">
                                    <v-icon class="mr-2">mdi-open-in-new</v-icon>
                                    {{ $t('views.main.api.api.api_samples_link') }}
                                </a>
                            </p>
                            <p>
                                <a href="/packages/export/xlsx">
                                    <v-icon class="mr-2">mdi-download</v-icon>
                                    {{ $t('views.main.api.api.package_codes_link') }}
                                </a>
                            </p>
                            <p>
                                <a href="/storage/exports/packages-availability.json" target="_blank">
                                    <v-icon class="mr-2">mdi-download</v-icon>
                                    {{ $t('views.main.api.api.package_state_export_link', {file_format: '.json'}) }}
                                </a> -
                                {{ $t('views.main.api.api.package_state_export_link_info') }}
                            </p>
                            <p>
                                <a href="/storage/exports/packages-availability.pdf" target="_blank">
                                    <v-icon class="mr-2">mdi-download</v-icon>
                                    {{ $t('views.main.api.api.package_state_export_link', {file_format: '.pdf'}) }}
                                </a> -
                                {{ $t('views.main.api.api.package_state_export_link_info') }}
                            </p>
                            <p>
                                <a href="/storage/exports/packages-availability.xml" target="_blank">
                                    <v-icon class="mr-2">mdi-download</v-icon>
                                    {{ $t('views.main.api.api.package_state_export_link', {file_format: '.xml'}) }}
                                </a> -
                                {{ $t('views.main.api.api.package_state_export_link_info') }}
                                {{ $t('views.main.api.api.package_state_export_xml_jarstol_format') }}
                            </p>
                            <p>
                                <a href="/storage/exports/offer.xml" target="_blank">
                                    <v-icon class="mr-2">mdi-download</v-icon>
                                    {{ $t('views.main.api.api.package_state_export_link', {file_format: '.xml'}) }}
                                </a> -
                                {{ $t('views.main.api.api.package_state_export_link_info_daily') }}
                                {{ $t('views.main.api.api.package_state_export_xml_pepita_format') }}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card class="my-5">
                        <v-card-title class="headline">
                            <v-icon class="mr-2">mdi-key-variant</v-icon>
                            {{ $t('views.main.api.api.api_tokens') }}
                            <v-spacer></v-spacer>
                            <v-btn
                                color="secondary"
                                text
                                small
                                rounded
                                :title="$t('views.main.api.api.new_token')"
                                @click="showCreateDialog"
                            >
                                <v-icon :class="{'mr-2':!IsMobile}">mdi-plus-circle-outline</v-icon>
                                <template v-if="!IsMobile">
                                    {{ $t('views.main.api.api.new_token_button') }}
                                </template>
                            </v-btn>
                        </v-card-title>

                        <v-card-text>
                            <loading-message
                                v-if="tokenIndexing"
                                :message="$t('views.main.api.api.loading_tokens')"
                                class="my-5"></loading-message>
                            <v-simple-table v-else-if="tokens.length">
                                <template v-slot:default>
                                    <tbody>
                                    <tr
                                        v-for="token in tokens"
                                        :key="token.id"
                                    >
                                        <td>
                                            <strong>{{ token.name }}</strong>,
                                            {{ $t('views.main.api.api.created_at') }}
                                            <span class="text-no-wrap">
                                            {{ token.created_at | dateConvenientFormat }}
                                        </span><br >
                                            <small class="text--secondary">
                                                {{ $t('views.main.api.api.last_used_at') }}
                                                <span class="text-no-wrap">
                                                <template v-if="token.last_used_at">
                                                    {{ token.last_used_at | dateConvenientFormat }}
                                                </template>
                                                <template v-else>-</template>
                                            </span>
                                            </small>
                                        </td>
                                        <td class="text-right">
                                            <v-btn
                                                icon
                                                @click="showDeleteDialog(token)"
                                            >
                                                <v-icon>mdi-trash-can-outline</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <v-alert
                                v-else
                                border="left"
                                colored-border
                                type="info"
                                elevation="1"
                            >{{ $t('views.main.api.api.no_tokens') }}</v-alert>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
            v-model="tokenCreateDialog"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    {{ $t('views.main.api.api.new_token') }}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideCreateDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-text-field
                        v-model="tokenForm.name"
                        :label="$t('views.main.api.api.token_name_label')+'*'"
                        :hint="$t('views.main.api.api.token_name_hint')"
                        autocomplete="off"
                        maxlength="255"
                        :counter="255"
                        :error="$store.getters.hasValidationError('name')"
                        :error-messages="$store.getters.validationError('name')"
                    ></v-text-field>
                    <small>* {{ $t('views.main.api.api.field_required') }}</small>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="tokenStore"
                        :loading="tokenStoring"
                    >{{ $t('views.main.api.api.add_button') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="tokenDeleteDialog"
            persistent
            width="500"
        >
            <v-card v-if="tokenToDelete">
                <v-card-title class="headline grey lighten-2 mb-5">
                    {{ $t('views.main.api.api.token_removal') }}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideDeleteDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    {{ $t('views.main.api.api.sure_to_remove_token') }}
                    <strong>{{tokenToDelete.name}}</strong>?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        rounded
                        @click="tokenDelete(tokenToDelete)"
                        :loading="tokenDeleting"
                    >{{ $t('views.main.api.api.delete_button') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="newTokenCreatedDialog"
            persistent
            max-width="650"
        >
            <v-card v-if="newToken">
                <v-card-title class="headline grey lighten-2 mb-5">
                    {{ $t('views.main.api.api.token_created') }}
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideNewTokenCreatedDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="text-justify">
                    {{ $t('views.main.api.api.new_token_information') }}
                </v-card-text>

                <v-card-text>
                    <v-alert text type="success" class="text-center">{{ newToken }}</v-alert>
                </v-card-text>

                <v-divider></v-divider>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoadingMessage from "../../../components/LoadingMessage";

export default {
    name: "Api",
    components: {
        LoadingMessage,
    },
    data() {
        return {
            tokenIndexing: false,
            tokens: [],

            tokenCreateDialog: false,
            tokenStoring: false,
            newTokenCreatedDialog: false,
            newToken: null,

            tokenDeleteDialog: false,
            tokenToDelete: null,
            tokenDeleting: false,

            tokenForm: {
                name: null,
            },
        };
    },
    computed: {
        IsMobile() {
            return this.$vuetify.breakpoint.mobile;
        },
    },

    methods: {
        tokenIndex: function () {
            this.tokenIndexing = true;

            this.$store.dispatch('tokenIndex')
                .then(response => {
                    if (response.status === 200) {
                        this.tokens = response.data.data;
                    } else {
                        this.$store.commit(
                            "showSnackbarError",
                            this.$t('views.main.api.api.loading_tokens_failed')
                        );
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.tokenIndexing = false;
                });
        },
        tokenStore: function () {
            this.tokenStoring = true;

            this.$store.dispatch('tokenStore', this.tokenForm).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideCreateDialog();
                    this.$store.commit(
                        "showSnackbarSuccess",
                        this.$t('views.main.api.api.token_created')
                    );
                    // noinspection JSUnresolvedVariable
                    this.newToken = response.data.data.plainTextToken;
                    this.tokenIndex();
                } else {
                    this.$store.commit(
                        "showSnackbarError",
                        this.$t('views.main.api.api.token_creation_failed')
                    );
                }
            })
                .catch(() => {})
                .then(() => {
                    this.tokenStoring = false;
                });
        },
        tokenDelete: function (token) {
            this.tokenDeleting = true;

            this.$store.dispatch('tokenDelete', token.id).then(response => {
                if (response.status === 204) {
                    this.hideDeleteDialog();
                    this.$store.commit(
                        "showSnackbarSuccess",
                        this.$t('views.main.api.api.token_deleted')
                    );
                    this.tokenIndex();
                } else {
                    this.$store.commit(
                        "showSnackbarError",
                        this.$t('views.main.api.api.token_deleting_failed')
                    );
                }
            })
                .catch(() => {})
                .then(() => {
                    this.tokenDeleting = false;
                });
        },
        showCreateDialog: function () {
            this.tokenCreateDialog = true;
        },
        hideCreateDialog: function () {
            this.tokenCreateDialog = false;
            this.resetTokenForm();
            this.$store.commit("resetValidation");
        },
        hideNewTokenCreatedDialog: function () {
            this.newTokenCreatedDialog = false;
        },
        showDeleteDialog: function (token) {
            this.tokenToDelete = token;
        },
        hideDeleteDialog: function () {
            this.tokenDeleteDialog = false;
        },
        resetTokenForm: function () {
            for (const index in this.tokenForm) {
                this.tokenForm[index] = null;
            }
        },
        setTokenForm: function (token) {
            this.tokenForm.name = token.name;
        },
    },
    created() {
        this.tokenIndex();
    },
    watch: {
        tokenToDelete: function (token) {
            if(token !== null) {
                this.tokenDeleteDialog = true;
            }
        },
        tokenDeleteDialog: function (visible) {
            if(!visible) {
                this.tokenToDelete = null;
            }
        },
        newToken: function (token) {
            if(token !== null) {
                this.newTokenCreatedDialog = true;
            }
        }
    },
}
</script>

<style scoped>

</style>
